import { Chip, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { ChannelItemActionPlan } from '../../../../sic-lib/types/ChannelItem';

interface Props {
    channelItem: ChannelItemActionPlan;
}

export default React.memo(function ConversationListItemActionPlan({ channelItem }: Props) {
    return (
        <Stack spacing={2} p={2}>
            <Typography variant="body1" display="block" whiteSpace="pre-wrap">
                {channelItem.body}
            </Typography>
            {!!channelItem.sRContactPlanItemId && (
                <Chip
                    label="Sent by Automatic Smart Reply"
                    color="info"
                    variant="outlined"
                    size="small"
                    sx={{ m: 2, display: 'flex' }}
                />
            )}
        </Stack>
    );
});
